import initMenu from '../components/menu';
import initScroll from '../components/scroll';
import initAccordionMenu from '../components/accordion-menu';
import initAccordionFaqlibMenu from '../components/accordion-faqlib';
import initForms from '../components/forms';

export default function initGeneral() {

  initMenu();
  initScroll();
  initAccordionMenu();
  initAccordionFaqlibMenu();
  initForms();

}
